import RootLayout from "@/components/Ui/Tools/RootLayout/RootLayout";
import { SITE_NAME } from "@/helper/constant";
import { baseURL } from "@/services/api";
import { ICategory, ICategoryGeneric } from "global-types/global.types";
import { GetStaticProps } from "next";
import Head from "next/head";
import Link from "next/link";
import styled from "styled-components";

interface IPrivacy {
  data: {
    text: string;
  };
}

interface Props {
  locale: string;
  data: IPrivacy;
}

export default function Privacy({ locale, data }: Props) {
  return (
    <>
      <Head>
        <title>{SITE_NAME} Privacy</title>
      </Head>
      <Wrapper>
        <div className="terms">
          <div className="breadcrumb">
            <Link href={`/${locale}`}>Ana səhifə</Link>
            <span className="breadcrumb-seperator" />
            <Link href={`/${locale}/privacy`}>Privacy Policy</Link>
          </div>
          <div className="terms-content">
            <h1 className="title">Privacy Policy</h1>
            <p>{data.data.text}</p>
          </div>
        </div>
      </Wrapper>
    </>
  );
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  try {
    const { locale } = ctx;

    const termsData = await fetch(baseURL + "/privacy-policy", {
      headers: {
        "x-localization": locale ? locale : "az",
      },
    });

    return {
      props: {
        locale,
        data: await termsData.json(),
      },
      revalidate: 60,
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
};

const Wrapper = styled.div`
  min-height: calc(100vh - 400px);

  .terms {
    width: 1289px;
    margin: 0 auto;
    padding-bottom: 7rem;
    padding-top: 3.2rem;

    .terms-content {
      margin-top: 36px;
      width: 812px;
      margin: auto;

      h1.title {
        font-style: normal;
        font-weight: bold;
        font-size: 3.6rem;
        line-height: 150%;
        color: #040941;
        margin-bottom: 2.4rem;
        text-align: center;
        margin-top: 3.2rem;
      }

      p {
        font-style: normal;
        font-weight: 500;
        font-size: 2rem;
        line-height: 30px;
        color: #989eaf;
        margin-bottom: 1.6rem;
      }
    }

    @media (max-width: 1199px) {
      width: 100%;
      padding: 0 16px;

      .terms-content {
        width: 100%;

        h5.title {
          font-size: 2.8rem;
        }

        p {
          font-size: 1.6rem;
        }
      }
    }
  }
`;
